import { ingredientLineName } from "@/types/recipe";
import type { Recipe } from "@/types/recipe";
import type { SubIngredientRow } from "./shared-types";

/**
 * A recipe's lines as the expandable sub-rows both recipe tables show.
 *
 * A line names an ingredient or another recipe, never both (T-703), so nothing
 * here may reach through `material` — a sub-recipe line has none. Allergens for
 * such a line live in that recipe's own lines and are not carried on the line
 * itself; the cooking deck and the order ticket walk the tree for them, which is
 * where a missed allergen would matter.
 */
export function toSubIngredientRows(recipe: Recipe): SubIngredientRow[] {
  return (recipe.ingredients ?? []).map((ing) => {
    const material = ing.material;
    const allergenNames = [
      ...(material?.allergens ?? []).map((a) => a.allergen.name),
      ...(material?.subIngredients ?? []).flatMap((sub) =>
        (sub.childMaterial.allergens ?? []).map((a) => a.allergen.name),
      ),
    ];
    const uniqueAllergens = [...new Set(allergenNames)];

    return {
      id: ing.id,
      ingredientCode: material?.sku ?? undefined,
      name: ingredientLineName(ing),
      quantity: Number(ing.quantity),
      unit: ing.unit,
      prepNotes: ing.preparationNotes ?? undefined,
      allergens: uniqueAllergens.length > 0 ? uniqueAllergens.join(", ") : undefined,
      isSubRecipe: ing.subRecipeId !== null || material?.type === "COMPOUND",
    };
  });
}
